import React from 'react';
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from 'recharts';

const BarChartComponent = () => {
  const bookingData = [
    { date: '2024-11-09', totalTechnicians: 12, availableTechnicians: 12 },
    { date: '2024-11-10', totalTechnicians: 8, availableTechnicians: 7 },
    { date: '2024-11-11', totalTechnicians: 15, availableTechnicians: 12 },
    { date: '2024-11-12', totalTechnicians: 9, availableTechnicians: 5 },
    { date: '2024-11-13', totalTechnicians: 18, availableTechnicians: 14 },
    { date: '2024-11-14', totalTechnicians: 22, availableTechnicians: 16 },
    { date: '2024-11-15', totalTechnicians: 10, availableTechnicians: 5 },
  ];

  function convertDate(data) {
      data.forEach((d) => {
        const nd = d.date.split('-')
        d.date = nd[2] + '-' + nd[1]
      })
      return data
  }

  

  return (
    <ResponsiveContainer width="100%" height={400}>
      <BarChart 
        data={convertDate(bookingData)} 
        margin={{ top: 20, right: 30, left: 2, bottom: 20 }}
      >
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="date" />
        <YAxis />
        <Tooltip />
        <Legend />
        <Bar 
          dataKey="totalTechnicians" 
          fill="#1814F3" 
          name="Total Technicians" 
          barSize={12} // Bar width
          radius={[6, 6, 6, 6]} 
        />
        <Bar 
          dataKey="availableTechnicians" 
          fill="#16DBCC" 
          name="Available Technicians" 
          barSize={12} // Bar width
          radius={[6, 6, 6, 6]} 
        />
      </BarChart>
    </ResponsiveContainer>
  );
};

export default BarChartComponent;
